import { io } from 'socket.io-client'

const URL = window._env_.REACT_APP_BASE_URL_SOCKET || 'https://localhost:4000'

export const socket = io(URL)
